import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const { user } = useAuth();
  const [unread, setUnread] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) {
      setUnread(0);
      return;
    }
    try {
      const { data } = await api.get("/notifications/unread-count");
      setUnread(data.count || 0);
    } catch {
      setUnread(0);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const markAllRead = async () => {
    if (!user) return;
    try {
      await api.post("/notifications/read-all");
      setUnread(0);
    } catch {
      /* ignore */
    }
  };

  const markRead = async (id) => {
    if (!user) return;
    try {
      await api.patch(`/notifications/${id}/read`);
      setUnread((v) => Math.max(0, v - 1));
    } catch {
      /* ignore */
    }
  };

  // Optimistically bump the count when a new notification arrives locally
  const bump = () => setUnread((v) => v + 1);

  return (
    <NotificationContext.Provider value={{ unread, refresh, markAllRead, markRead, bump }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
